export const TRACKING = {
    VALIDATE_FROM_BANNER: 'askForEmailValidationBanner_EmailRequested'
};
